import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Helmet } from '@/common/components/Helmet'

export const Route = createFileRoute('/app/account/register/verification')({
  beforeLoad: ({ context }) => {
    const currentUser = context.currentUser

    if (!currentUser) return

    if (!currentUser.loading && currentUser.isVerified) {
      throw redirect({
        to: '/app/account/dashboard',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Outlet />
    </>
  )
}
